import { Box, Checkbox, FormControlLabel, InputBase, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next"
import { tokens } from "../../../theme";
import Text from "../../theme/text/Text";
import { useEffect, useState } from "react";
import { ShColorPicker } from "../../ShColorPicker";
import { hexToRgb } from "../../../utils/colorConverters";

export const SHPBSpiral = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const {t} = useTranslation();

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [activeStopIndex, setActiveStopIndex] = useState(null);
    const filterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = filterPopoverOpen ? "simple-popover" : undefined;
    
    const handleFilterPopoverClick = (event, index) => {
      setFilterAnchorEl(event.currentTarget);
      setActiveStopIndex(index);  // Track which stop was clicked
    };
    
    const handleFilterPopoverClose = () => {
      setFilterAnchorEl(null);
      setActiveStopIndex(null);
    };

    const [gradient, setGradient] = useState(props.value.gradient || {
        type: 'radial',
        colorStops: [
            {
                hex: "#FFFFFF",
                puck: {
                    x: 0,
                    y:0,
                },
                opacity:1,
                position:0,
            },
            {
                hex: "#000000",
                puck: {
                    x: 0,
                    y:0,
                },
                opacity:1,
                position:1,
            },
        ]
        // angle: 90,
    });
      
    useEffect(() => {
        if (props.value && props.value.gradient) {
            setGradient(props.value.gradient);
        }
    }, [props.value]);

    const handleCheckboxChange = (e) => {
        props.setValue({
            ...props.value,
            visible: e.target.checked,
        })
    }
    const changeOpacity = (e,idx) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
          let numericValue = Number(value);
      
          if (numericValue < 0) numericValue = 0;
          else if (numericValue > 100) numericValue = 100;
      
          if (props.setValue) {
            const newStops = [...gradient.colorStops];
            newStops[idx] = {
              ...newStops[idx],
              opacity: numericValue / 100,
            };
            props.setValue({
                ...props.value,
                gradient: { 
                    ...props.value.gradient, 
                    type: props.value?.gradient?.type ?? "radial",
                    colorStops: newStops 
                },
            });
          }
        }
      };

      
    return (
        <Box>
            <Text>
            {t("spiral")}
            </Text>
            <Box
                sx={{
                    // height:40,
                    // background:"grey",
                    width:1,
                }}
            >
                {/* <input 
                    type="checkbox" 
                    checked={props.value.visible || false} 
                    onChange={handleCheckboxChange}
                />
                <span>{t("visible")}</span> */}
                <FormControlLabel
                    control={
                        <Checkbox
                        checked={props.value.visible || false}
                        onChange={handleCheckboxChange}
                        size="small" // or "medium"
                        />
                    }
                    label={t("advanced")}
                />

                <Box
                    sx={{
                        display:"flex",
                        gap:1,
                        flexDirection:"column",
                        mt:1,
                    }}
                >
                    {props.value.visible && 
                        gradient.colorStops.map((stop, index) => (

                            <Box key={index}>
                                <Box
                                    sx={{
                                    }}
                                >
                                    <Text light>
                                    {t("color")}
                                    </Text>

                                    <Box
                                        sx={{
                                            display:"flex",
                                            height:40,
                                            background: colors.bg['tertiary'],
                                            alignItems:"center",
                                            pl:1,
                                            pr:1,
                                            borderRadius:5,
                                        }}
                                    >
                                        <Box
                                            onClick={(e) => handleFilterPopoverClick(e, index)}
                                            // onClick={handleFilterPopoverClick}
                                            sx={{
                                                borderRadius:3,
                                                height:24,
                                                width:24,
                                                flexShrink:0,
                                                background:stop.hex ? `rgba(${hexToRgb(stop.hex)},${stop.opacity})` : "#fff",
                                            }}
                                        >

                                        </Box>

                                        <InputBase
                                            value={stop.hex}
                                            // onChange={}
                                            sx={{
                                                ml:1.5,
                                                flex:1,
                                                color: colors.txt["primary"],
                                                fontFamily:"Roboto, sans-serif",
                                            }}
                                        />

                                        <Box
                                            sx={{
                                                height:24,
                                                background:colors.grey[200],
                                                borderRadius:4,
                                                display:"flex",
                                                alignItems:"center",
                                                pl:2,
                                                pr:1.5,
                                            }}
                                        >
                                            <InputBase
                                                onInput={(e) => changeOpacity(e,index)}
                                                value={stop.opacity ?   parseInt(stop.opacity * 100) : 100}
                                                sx={{
                                                    width:32,
                                                    color: colors.txt["primary"],
                                                    fontFamily:"Roboto, sans-serif",
                                                }}
                                            />
                                            <Text bold>%</Text>
                                        </Box>
                                    </Box>
                                    <ShColorPicker
                                        value={gradient.colorStops[activeStopIndex]}
                                        setValue={(value) => {
                                            if (activeStopIndex === null) return;
                                            const newStops = [...gradient.colorStops];
                                            newStops[activeStopIndex] = { ...newStops[activeStopIndex], ...value };
                                            props.setValue({
                                                ...props.value,
                                                gradient: { 
                                                    ...props.value.gradient, 
                                                    type: props.value?.gradient?.type ?? "radial",
                                                    colorStops: newStops 
                                                },
                                            });
                                        }}
                                        id={filterPopoverId}
                                        open={filterPopoverOpen}
                                        anchorEl={filterAnchorEl}
                                        onClose={handleFilterPopoverClose}
                                    
                                    />
                                </Box>
                            </Box>

                        ))
                    }
                </Box>
            </Box>
        </Box>
    )
}